import { ListIcon } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import React from 'react'

import { APP_TYPE } from '@/types/User'

import { AppSelection } from './AppSelection'
import { MenuItems } from './MenuItems'
import { Notifications } from './Notifications'
import { UserNavigation } from './UserNavigation'

type Props = {
  activeApp: APP_TYPE
  isUnreadNotifications: boolean
  minimize: boolean
  numberOfUnreadNotifications: number
  onNavLinkPress: (path: string) => void
  toggleSideBar: () => void
}

export const DesktopSidebarNavigation = ({
  onNavLinkPress,
  minimize,
  numberOfUnreadNotifications,
  toggleSideBar,
  activeApp,
  isUnreadNotifications,
}: Props) => {
  return (
    <SidebarStyled activeApp={activeApp} minimize={minimize}>
      <NavigationStyled activeApp={activeApp} minimize={minimize}>
        <ul className="grid">
          <button onClick={toggleSideBar}>
            <li className="mb-2 mt-1">
              <ListIcon />
              <span>Mission Control</span>
            </li>
          </button>
          <AppSelection activeApp={activeApp} minimize={minimize} smallScreen={false} />
          <MenuItems activeApp={activeApp} onNavLinkPress={onNavLinkPress} />

          <Notifications
            isUnreadNotifications={isUnreadNotifications}
            numberOfUnreadNotifications={numberOfUnreadNotifications}
            onNavLinkPress={onNavLinkPress}
          />
        </ul>

        <UserNavigation activeApp={activeApp} minimize={minimize} smallScreen={false} />
      </NavigationStyled>
    </SidebarStyled>
  )
}

const SidebarStyled = styled.div<{ activeApp: APP_TYPE; minimize: boolean }>`
  z-index: 50;
  position: fixed;
  top: 4rem;
  @media (min-width: 768px) {
    top: 0;
  }
  transform: translateX(0);
  overflow: visible;
  @media (min-width: 768px) {
    height: 100%;
  }
  ${({ activeApp }) =>
    activeApp === APP_TYPE.SALES ? 'border-right-width: 1px; border-right-style: solid; border-color: #E7E6E4;' : ''}
  transition: width 0.3s ease-out;
  ${({ minimize }) => (minimize ? 'width: 4rem; min-width: 4rem;' : 'width: 14rem; min-width: 14rem;')}
  :hover {
    > div {
      transform: translateX(0);
    }
  }
`

const NavigationStyled = styled.div<{ activeApp: APP_TYPE; minimize: boolean }>`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  transition-property: transform;
  transition-duration: 200ms;
  transition-timing-function: ease-in;
  ${({ activeApp }) => (activeApp === APP_TYPE.SALES ? 'background-color: white;' : 'background-color: #000000;')}

  ul {
    button {
      position: relative;
      padding-left: 1rem;
      padding-right: 1rem;
      overflow: hidden;

      &.active-selection {
        ${({ activeApp }) =>
          activeApp === APP_TYPE.SALES ? 'background-color: #E7E6E4;' : 'background-color: #2E2B29;'}
      }

      li {
        text-align: left;
        display: flex;
        align-items: center;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        font-size: 1rem;
        font-weight: 300;
        line-height: 1.75rem;
        width: 100%;
        position: relative;
        ${({ activeApp }) => (activeApp === APP_TYPE.SALES ? 'color: #000000;' : 'color: white;')}
      }

      svg {
        width: 1.5rem;
        ${({ minimize }) => !minimize && 'margin-right: 0.5rem;'}
      }

      span {
        ${({ minimize }) => (minimize ? 'display: none; opacity: 0;' : 'display: block; opacity: 1;')}

        ${({ activeApp }) => {
          if (activeApp !== APP_TYPE.SALES) {
            return 'font-weight: 700;'
          }
        }}
      }
    }
    .active-selection::before {
      position: absolute;
      width: 0.25rem;
      height: 100%;
      content: '';
      left: 0;
      background-color: #09a090;
    }
  }

  :hover {
    transform: translateX(0);
  }
`
